export enum UcVersion {
    Version_1 = 'Version_1',
    Version_2 = 'Version_2'
  }